/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  BUTTON_FORMAT_STRONG,
  BUTTON_THEME_DEFAULT,
  ButtonProps,
  DIALOG_SIZE_SM_MD,
  DialogContentProps,
  DialogProps,
  ICON_EDIT,
} from '@squiz/sds';
import { DialogLauncher } from 'apps/console-core/src/Components/DialogLauncher/DialogLauncher';
import { useDialogStore } from 'dxpConsoleCore-mf/State';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COMPONENT_SERVICE_STRINGS } from '../../../../Constants/Strings.constants';
import { EntityMatrixIdentifier } from '../../../../Services/component-content';
import { CONTENT_MATRIX_IDENTIFIER_DATA_IDS } from '../../ContentMatrixIdentifiers.constants';
import { EditContentMatrixIdentifierForm } from '../../forms/EditContentMatrixIdentifierForm/EditContentMatrixIdentifierForm';

/**
 * The props for `<EditContentMatrixIdentifier />`.
 */
interface EditContentMatrixIdentifierProps {
  matrixIdentifier: EntityMatrixIdentifier;
}

/**
 * The button for editing a matrix identifier.
 * @param {EditContentMatrixIdentifierProps} props Props passed to `<EditContentMatrixIdentifier />`.
 * @returns {JSX.Element} The `<EditContentMatrixIdentifier />` component.
 */
export const EditContentMatrixIdentifier = (props: EditContentMatrixIdentifierProps): JSX.Element => {
  const { t } = useTranslation();
  const buttonProps: ButtonProps = {
    format: BUTTON_FORMAT_STRONG,
    icon: ICON_EDIT,
    theme: BUTTON_THEME_DEFAULT,
  };
  const dialogProps: DialogProps = {
    dialogContent: {
      renderContent: (dialogProps: DialogContentProps): JSX.Element => {
        return <EditContentMatrixIdentifierForm {...dialogProps} matrixIdentifier={props.matrixIdentifier} />;
      },
    },
    dialogSize: DIALOG_SIZE_SM_MD,
    heading: t(COMPONENT_SERVICE_STRINGS.matrixIdentifierHeadingEdit),
    showDividers: true,
    stateHandler: useDialogStore,
  };
  return (
    <div data-id={CONTENT_MATRIX_IDENTIFIER_DATA_IDS.editIdentifier}>
      <DialogLauncher buttonProps={buttonProps} dialogProps={dialogProps} />
    </div>
  );
};
